import { render, staticRenderFns } from "./rada-vertical.vue?vue&type=template&id=04a8fc94&scoped=true"
import script from "./rada-vertical.vue?vue&type=script&lang=js"
export * from "./rada-vertical.vue?vue&type=script&lang=js"
import style0 from "./rada-vertical.vue?vue&type=style&index=0&id=04a8fc94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a8fc94",
  null
  
)

export default component.exports